import { render, staticRenderFns } from "./SecondaryNavbarComponent.vue?vue&type=template&id=64dcf104&"
import script from "./SecondaryNavbarComponent.vue?vue&type=script&lang=js&"
export * from "./SecondaryNavbarComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports